export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9221.efa3cfd5.jpg";